import { render, staticRenderFns } from "./chronic.vue?vue&type=template&id=6c190248"
import script from "./chronic.vue?vue&type=script&lang=js"
export * from "./chronic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports